import listenForResponseOnAlexa from './listenForResponseOnAlexa';

export default listenForResponseOnAlexa;
